import Button from "atoms/buttons/button";
import PublishStatus from "models/enumerations/publish-status";
import React, { forwardRef } from "react";
import { useGlobalState } from "utilities/contexts/use-global-state-context";
import { EnhancedContentPanelFooterProps } from "../enhanced-content-panel-footer";

// -----------------------------------------------------------------------------------------
// #region Interfaces
// -----------------------------------------------------------------------------------------

interface EnhancedContentDeleteActionProps
    extends Pick<EnhancedContentPanelFooterProps, "enhancedContent"> {
    onClick: () => void;
    ref?: React.RefObject<HTMLButtonElement>;
}

// #endregion Interfaces

// -----------------------------------------------------------------------------------------
// #region Components
// -----------------------------------------------------------------------------------------

const EnhancedContentDeleteAction = forwardRef(
    (
        props: EnhancedContentDeleteActionProps,
        ref: React.Ref<HTMLButtonElement>
    ) => {
        const { enhancedContent, onClick, ref: buttonRef } = props;

        const { globalState } = useGlobalState();

        const authorCanDelete =
            globalState.currentIdentity?.isAuthor() &&
            enhancedContent.getPublishStatus() !== PublishStatus.Published;

        const canDelete =
            authorCanDelete ||
            globalState.currentIdentity?.isAdmin() ||
            globalState.currentIdentity?.isPublisher();

        if (!canDelete) {
            return null;
        }

        return (
            <Button
                accessibleText="Delete Enhanced Content"
                onClick={onClick}
                ref={buttonRef}>
                Delete
            </Button>
        );
    }
);

// #endregion Components

// -----------------------------------------------------------------------------------------
// #region Exports
// -----------------------------------------------------------------------------------------

export default EnhancedContentDeleteAction;

// #endregion Exports
